// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d992aab3","467":"a6b634c1"}[chunkId] + ".chunk.js";
};